
import Navbar from "../Navbar"
// import '../../index.css';


import SignUpCard from "./signUpCard"

export default function SignUp(){
    return(<div className="loginContainer"  >
    <div className="tryi"><Navbar title="Login"/>
         <SignUpCard /></div>
         
        </div>
    
    
    )
}
